import { baseUrl } from "./config"
import axios from 'axios'

export const getSpeciesRecords = (code) => axios.get(`${baseUrl}/species/${code}`)
export const getSpeciesCurrent = (code) => axios.get(`${baseUrl}/species-current/${code}`)